<template>
    <div>
        <Head title="Projects"/>
        <h1 class="mb-8 text-3xl font-bold">Projects</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter :show-input="true" v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <template #dateFilter>
                    <date-picker v-model="form.date" :range="true" :time-picker="false"
                                 :enable-time-picker="false" input-class-name="dp-custom-input" :multi-calendars="2"
                                 :preset-ranges="presetRanges" auto-apply>
                    </date-picker>
                </template>
            </search-filter>
        </div>
        <!--cards wrapper-->
        <div class="container items-center px-4 py-8 m-auto mt-5">
            <div class="flex flex-wrap pb-3 mx-4 md:mx-24 lg:mx-0">


                <summary-card title="Total Projects" :totals=summary.total_project
                              :percentage_change=summary.project_change.percentage
                              :change_direction=summary.project_change.hasIncreased #cardIcon>
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Published Projects" :totals=summary.active_project
                              :percentage_change=summary.active_project_change.percentage
                              :change_direction=summary.active_project_change.hasIncreased #cardIcon
                              @click="applyFilter('published')"
                >
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="UnPublished Projects" :totals=summary.inActive_projects
                              :percentage_change=summary.inActive_projects_change.percentage
                              :change_direction=summary.inActive_projects_change.hasIncreased #cardIcon
                              @click="applyFilter('unpublished')"
                >
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>
                <summary-card title="Pending Approvals" :totals=pendingApprovals
                              :percentage_change=summary.inActive_projects_change.percentage
                              :change_direction=summary.inActive_projects_change.hasIncreased #cardIcon
                              @click="applyFilter('pendingApproval')"
                >
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

            </div>
        </div>
    </div>

    <Table :resource="projects">

        <template #cell(name)="{ item: project }">
            <a :href="`/projects/details/${project.id}`"
               class="py-4 px-6">
                {{ project.name }}
            </a>
        </template>

        <template #cell(owner)="{ item: project }">
            <a :href="`users/details/${project.user_id}`"
               class="py-4 px-6">
                {{ project.owner }}
            </a>
        </template>

        <template #cell(status)="{ item: project }">
            <button type="button"
                    :class="BindOrderStatus(project.status)">
                {{ project.status }}
            </button>
        </template>


        <template #cell(actions)="{ item: project }">

            <button v-if="project.published" tabindex="-1"
                    type="button" class="rejected_status"
                    @click="unPublish(project.id)">UnPublish
            </button>

            <button v-if="!project.published" tabindex="-1"
                    type="button" class="complete_status"
                    @click="publish(project.id)">Publish
            </button>

            <button v-if="canRejectProject(project)"
                    class="bg-red-700 text-white active:bg-red-500  text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    @click="rejectProject(project.id)"
            >
                Reject
            </button>


            <button v-if="canDeleteProject(project)"
                    @click="openDeleteModal(project.id)"
                    class="flex space-x-2 items-center px-3 py-2 bg-red-500 hover:bg-rose-800 rounded-md drop-shadow-md">
                <svg class="fill-white" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20"
                     height="20"
                     viewBox="0 0 24 24">
                    <path
                        d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z">
                    </path>
                </svg>
                <span class="text-white">Delete</span>
            </button>

        </template>

    </Table>

    <!--delete Project modal    -->
    <DialogModal :show="showDeleteModal">
        <!-- Modal content -->
        <template #title>
            <div class="flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700">
                <h3 class="text-xl font-semibold dark:text-white">
                    Delete Project
                </h3>
                <button type="button"
                        @click="closeDeleteModal"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white"
                        data-modal-toggle="add-user-modal">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"></path>
                    </svg>
                </button>
            </div>
        </template>

        <!-- Modal body -->

        <template #content>
            <input type="hidden" v-model="deleteForm.id">
            <div class="p-6 pt-0 text-center">
                <svg class="w-16 h-16 mx-auto text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                     xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <h3 class="mt-5 mb-6 text-lg text-gray-500 dark:text-gray-400">Are you sure you want to delete this
                    Project?</h3>
                <button
                    @click="deleteProject"
                    class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-base inline-flex items-center px-3 py-2.5 text-center mr-2 dark:focus:ring-red-800">
                    Yes, I'm sure
                </button>
                <button
                    @click="closeDeleteModal"
                    class="text-gray-900 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-primary-300 border border-gray-200 font-medium inline-flex items-center rounded-lg text-base px-3 py-2.5 text-center dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                    data-modal-toggle="delete-user-modal">
                    No, cancel
                </button>
            </div>
        </template>

        <!-- Modal footer -->
        <template #footer>

        </template>

    </DialogModal>


</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import SummaryCard from "@/Shared/SummaryCard";
import Pagination from '@/Shared/Pagination'
import {Table} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths, subYears
} from "date-fns";
import DialogModal from "@/Shared/DialogModal.vue";


export default {
    components: {
        DialogModal,
        Head,
        Icon,
        Link,
        SearchFilter,
        SummaryCard,
        Pagination,
        Table
    },
    layout: Layout,
    props: {
        filters: Object,
        projects: Array,
        summary: Object,
        pendingApprovals: Number
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                date: this.filters.date,
            },
            deleteForm: {
                id: ''
            },

            showDeleteModal: false,

            cardTwoLink: "/projects?status=published",
            cardOThreeLink: "/projects?status=unpublished",
            cardFourLink: "/projects?status=pendingApproval",


            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/projects', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        BindOrderStatus: function (status) {
            if (status === "completed" || status === 'active' || status === 'ongoing') {
                return "complete_status";
            } else if (status === "cancelled" || status === "rejected") {
                return "rejected_status"
            } else {
                //todo add pending  and submitted status
                return "pending_status"
            }
        },

        unPublish(id) {
            if (confirm('Are you sure you want Unpublish this Project?')) {
                this.$inertia.post(`projects/unPublish/${id}`)
            }
        },

        publish(id) {
            if (confirm('Are you sure you want to publish this Project?')) {

                this.$inertia.post(`projects/publish/${id}`)
            }
        },

        canRejectProject(project) {
            if (project.status !== "rejected" && !project.published) {
                return true;
            } else {
                return false;
            }
        },
        canDeleteProject(project) {
            if (project.photos_count === 0 && project.expenses_sum == 0.00 && project.total_orders === 0) {
                return true
            } else {
                return false;

            }
        },

        openDeleteModal(id) {
            this.deleteForm.id = id
            this.showDeleteModal = true;
        },


        closeDeleteModal() {
            this.showDeleteModal = false;
        },
        deleteProject() {
            let id = this.deleteForm.id;
            this.$inertia.post(`/projects/delete/${id}`, pickBy(this.deleteForm), {preserveState: true});
            this.closeDeleteModal();
        },
        rejectProject(id) {
            if (confirm('Are you sure you want to Reject this Project?')) {

                this.$inertia.post(`projects/reject/${id}`)
            }
        },
        applyFilter(status) {
            const currentUrl = window.location.href;
            let updatedUrl = currentUrl;

            if (currentUrl.includes('?')) {
                updatedUrl = updatedUrl.replace(/(\?|&)status=[^&]+/, '');
                updatedUrl += `&status=${status}`;

            } else {
                updatedUrl += `?status=${status}`;
            }

            // Use Inertia.js to reload the page with the updated URL
            this.$inertia.visit(updatedUrl, {preserveScroll: true});
        },
    },
}
</script>
